import * as constants from './constants';

export const getProject = (payload) => ({ type: constants.GET_PROJECT, payload });
export const getProjectSuccess = (payload) => ({ type: constants.GET_PROJECT_SUCCESS, payload });
export const getProjectError = (payload) => ({ type: constants.GET_PROJECT_ERROR, payload });

export const resetProject = () => ({ type: constants.RESET_PROJECT });
export const resetProjectEntityData = () => ({ type: constants.RESET_PROJECT_ENTITY_DATA });

export const deleteProjects = (payload) => ({ type: constants.DELETE_PROJECTS, payload });
// eslint-disable-next-line max-len
export const deleteProjectsSuccess = (payload) => ({ type: constants.DELETE_PROJECTS_SUCCESS, payload });
// eslint-disable-next-line max-len
export const deleteProjectsError = (payload) => ({ type: constants.DELETE_PROJECTS_ERROR, payload });

export const deleteProject = (payload) => ({ type: constants.DELETE_PROJECT, payload });
export const deleteProjectSuccess = () => ({ type: constants.DELETE_PROJECT_SUCCESS });
export const deleteProjectError = (payload) => ({ type: constants.DELETE_PROJECT_ERROR, payload });

export const createProject = (payload) => ({ type: constants.CREATE_PROJECT, payload });
export const createProjectSuccess = () => ({ type: constants.CREATE_PROJECT_SUCCESS });
export const createProjectError = (payload) => ({ type: constants.CREATE_PROJECT_ERROR, payload });

export const batchAddToProject = (payload) => ({ type: constants.BATCH_ADD_TO_PROJECT, payload });
export const batchAddToProjectSuccess = () => ({ type: constants.BATCH_ADD_TO_PROJECT_SUCCESS });
// eslint-disable-next-line max-len
export const batchAddToProjectError = (payload) => ({ type: constants.BATCH_ADD_TO_PROJECT_ERROR, payload });

export const editProject = (payload) => ({ type: constants.EDIT_PROJECT, payload });
export const editProjectSuccess = () => ({ type: constants.EDIT_PROJECT_SUCCESS });
export const editProjectError = (payload) => ({ type: constants.EDIT_PROJECT_ERROR, payload });

export const selectProjectDetailsItem = (payload) => ({ type: constants.SELECT_PROJECT_DETAILS_ITEM, payload });
export const deselectProjectDetailsItem = (payload) => ({ type: constants.DESELECT_PROJECT_DETAILS_ITEM, payload });
export const selectProjectDetailsImage = (payload) => ({ type: constants.SELECT_PROJECT_DETAILS_IMAGE, payload });
export const deselectProjectDetailsImage = (payload) => ({ type: constants.DESELECT_PROJECT_DETAILS_IMAGE, payload });
export const selectProjectDetailsSet = (payload) => ({ type: constants.SELECT_PROJECT_DETAILS_SET, payload });
export const deselectProjectDetailsSet = (payload) => ({ type: constants.DESELECT_PROJECT_DETAILS_SET, payload });
export const selectProjectDetailsColor = (payload) => ({ type: constants.SELECT_PROJECT_DETAILS_COLOR, payload });
export const deselectProjectDetailsColor = (payload) => ({ type: constants.DESELECT_PROJECT_DETAILS_COLOR, payload });
export const resetProjectDetailsColors = () => ({ type: constants.RESET_PROJECT_DETAILS_COLOR });
export const resetProjectDetailsSets = () => ({ type: constants.RESET_PROJECT_DETAILS_SET });
export const resetProjectDetailsImages = () => ({ type: constants.RESET_PROJECT_DETAILS_IMAGE });
export const resetProjectDetailsItems = () => ({ type: constants.RESET_PROJECT_DETAILS_ITEM });

export const batchRemoveFromProject = (payload) => ({ type: constants.BATCH_REMOVE_FROM_PROJECT, payload });
export const batchRemoveFromProjectSuccess = () => ({ type: constants.BATCH_REMOVE_FROM_PROJECT_SUCCESS });
// eslint-disable-next-line max-len
export const batchRemoveFromProjectError = (payload) => ({ type: constants.BATCH_REMOVE_FROM_PROJECT_ERROR, payload });
